import { z } from "zod";

const substitutionPlanNotificationBaseItemSchema = z.object({
	substitutionPlanId: z.uuid(),
	orgId: z.string(),
	personId: z.string(),
	type: z.enum(["contact", "assignment"]),
});

export type SubstitutionPlanNotificationBaseItemSchema = z.infer<
	typeof substitutionPlanNotificationBaseItemSchema
>;

export const substitutionPlanNotificationBaseSchema = z.array(
	substitutionPlanNotificationBaseItemSchema,
);

export type SubstitutionPlanNotificationBaseSchema = z.infer<
	typeof substitutionPlanNotificationBaseSchema
>;
